import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { SignupResultLayout } from '../SignupResultLayout/SignupResultLayout';
import { signupErrorStyles } from './SignupError.styles';

export type SignupErrorCode = 'user_archived' | 'verification_link_expired';

interface SignupErrorProps {
  errorCode: SignupErrorCode | null;
}

export function SignupError({errorCode}: SignupErrorProps) {
  const theme = useTheme();
  const content = errorCode === 'user_archived'
    ? {
        title: 'This account is archived',
        message: 'Contact your school or district administrator, or Exploros Support, to restore access.',
      }
    : errorCode === 'verification_link_expired'
      ? {
          title: 'This signup link has expired',
          message: 'Return to signup to request a new verification email. If you already completed signup, log in instead.',
        }
      : {
          title: 'We couldn’t finish your signup',
          message: 'Please return to signup and try again. If the problem continues, contact Exploros support.',
        };

  return (
    <SignupResultLayout title={content.title}>
      <Typography sx={signupErrorStyles.resultMessage(theme)}>{content.message}</Typography>
      <Box sx={signupErrorStyles.resultActions()}>
        {errorCode === 'verification_link_expired' && <Button href="/login" color="success" variant="contained">Log in</Button>}
        <Button href="/signup" color="success" variant="outlined">Return to signup</Button>
      </Box>
    </SignupResultLayout>
  );
}
